<aside id="sidebar">
	<div class="brand action-container">
    <a routerLink="default">
      <img *ngIf="_gearAppService.GearPermissionList" [src]="_clientLogoBar" height="100%" />
    </a>
	</div>
	<div class="nav-scroll main-content">
		<div class="nav flex-column">
			<div *ngFor="let item of sidebarItems; let e = index;">
        <li class="nav-item nav-title" *ngIf="item.Type === 1 && item.Title">
          {{item.Title}}
        </li>
        <div *ngFor="let itemLevel1 of item.children; let i = index;">
          <li class="nav-item" *ngIf="itemLevel1?.children.length < 1 && itemLevel1?.url">
            <a
              class="nav-link"
              tabindex="0"
              [routerLink]="itemLevel1.url"
              routerLinkActive="active"
              [attr.id]="'sidebar-'+itemLevel1.MenuID"
            >
              <span class="fa-stack">
                <i [attr.class]="(itemLevel1.SidebarSettings?.Icon) ? itemLevel1.SidebarSettings.Icon : itemLevel1.Icon"></i>
              </span>
              {{itemLevel1.Title}} <img *ngIf="itemLevel1.ShowStar" [src]="_appService.getAddOnStarIcon()" class="ml-1" style="max-width: 20px;">
            </a>
          </li>
          <li class="nav-item" *ngIf="itemLevel1?.children?.length > 0">
            <a
              [attr.id]="'sidebar-'+itemLevel1.MenuID"
              class="nav-link"
              [ngClass]="{'active': collapses[itemLevel1.index] === false}"
              tabindex="0"
              (click)="collapse(itemLevel1.index)"
              [attr.data-index]="itemLevel1.index"
              [attr.aria-expanded]="!collapses[itemLevel1.index]"
              [attr.aria-controls]="'collapses'+itemLevel1.index"
            >
              <span class="fa-stack">
                <i [attr.class]="(itemLevel1.SidebarSettings?.Icon) ? itemLevel1.SidebarSettings.Icon : itemLevel1.Icon"></i>
              </span>
              {{itemLevel1.Title}}
              <span class="collapse-arrow">
                <i class="fa fa-chevron-right"></i>
              </span>
            </a>
          </li>
          <div
            [attr.id]="'collapses'+itemLevel1.index"
            [collapse]="(collapses[itemLevel1.index] === undefined) ? true : collapses[itemLevel1.index]"
            [isAnimated]="true"
            *ngIf="itemLevel1?.children?.length > 0"
          >
            <div class="nav flex-column">
              <li class="nav-item" *ngFor="let itemLevel2 of itemLevel1.children; let j = index;">
                <a
                  class="nav-link"
                  tabindex="0"
                  *ngIf="itemLevel2.url"
                  [routerLink]="itemLevel2.url"
                  routerLinkActive="active"
                  [attr.id]="'sidebar-'+itemLevel2.MenuID"
                >
                  {{itemLevel2.Title}} <img *ngIf="itemLevel2.ShowStar" [src]="_appService.getAddOnStarIcon()" class="ml-1" style="max-width: 20px;">
                </a>
              </li>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</aside>
<div class="sidebar-backdrop" (click)="_appService.sidebarToggler()"></div>
